import Image from "next/image";

import { useI18n } from "utils/with-i18n.utils";

export const Reconditioned = () => {
  const i18n = useI18n();

  return (
    <div className="relative bg-white">
      <div className="absolute top-[-250px] left-0 z-10 w-full h-[250px] bg-white"></div>
      <section className="flex flex-col gap-6 justify-between items-center pt-3 mx-auto w-full max-w-[90rem] lg:flex-row lg:px-3 xl:px-[120px] 2xl:px-[90px]">
        <article className="flex flex-col gap-3 px-[30px] h-full md:gap-6 lg:py-16 lg:px-0 lg:mb-[98px] lg:w-1/2">
          <h3 className="text-[30px] font-black leading-8 text-center md:text-[42px] md:leading-[42px] lg:text-left">
            {i18n.t("environment.reconditioned.title", {}, { html: true })}
          </h3>
          <p className="[&_.footer]:text-[20px] [&_.footer]:lg:text-[24px] text-[16px] [&_.font-bold]:font-bold leading-[24px] [&_a]:text-cornflower-blue [&_.text-pastel-green-2]:text-pastel-green-2 [&_a]:underline lg:text-[18px] lg:leading-[30px]">
            {i18n.t("environment.reconditioned.text", {}, { html: true })}
          </p>
        </article>

        <div className="hidden max-w-[50%] lg:block">
          <Image
            src={"/images/environment/reconditioned.webp"}
            alt="A person replacing a phone screen"
            width={1120}
            height={877}
          />
        </div>
        <div className="w-full lg:hidden">
          <Image
            src={"/images/environment/reconditioned-mobile.webp"}
            alt="A person replacing a phone screen"
            className="object-cover"
            width={390}
            height={251}
          />
        </div>
      </section>
    </div>
  );
};
